/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit2_DInputs */

const en_minifier_pit2_d = /** @type {(inputs: Minifier_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A JSON string containing an escaped newline keeps it, because removing it would change the data. If you expected a multi line string to collapse onto one line, minification is not the tool for that. Rewrite the value itself.`)
};

const ko_minifier_pit2_d = /** @type {(inputs: Minifier_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이스케이프된 줄바꿈을 담은 JSON 문자열은 그것을 유지합니다. 제거하면 데이터가 바뀌기 때문입니다. 여러 줄 문자열이 한 줄로 합쳐지기를 기대했다면 압축은 그 도구가 아닙니다. 값 자체를 다시 쓰세요.`)
};

const ja_minifier_pit2_d = /** @type {(inputs: Minifier_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エスケープされた改行を含む JSON 文字列はそれを保ちます。取り除けばデータが変わるからです。複数行の文字列が 1 行にまとまることを期待していたなら、圧縮はその道具ではありません。値そのものを書き直してください。`)
};

/**
* | output |
* | --- |
* | "A JSON string containing an escaped newline keeps it, because removing it would change the data. If you expected a multi line string to collapse onto one lin..." |
*
* @param {Minifier_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit2_d = /** @type {((inputs?: Minifier_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit2_d(inputs)
	if (locale === "ko") return ko_minifier_pit2_d(inputs)
	return ja_minifier_pit2_d(inputs)
});